"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const socket_context_1 = require("@src/context/socket-context");
const MissingContentView_1 = __importDefault(require("@src/components/modules/MissingContentView/MissingContentView"));
const ApplicationListItem_1 = __importDefault(require("./ApplicationListItem"));
const getOfferApplicationStages_1 = require("./getOfferApplicationStages");
const ApplicationList = ({ applicationsStatuses, isSmallLayout, intl }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: applicationsStatuses.map(applicationStatus => {
        const { marks, value } = (0, getOfferApplicationStages_1.getOfferApplicationStages)(applicationStatus, isSmallLayout, intl);
        return ((0, jsx_runtime_1.jsx)(ApplicationListItem_1.default, { application: applicationStatus, marks: marks, value: value }, applicationStatus.id));
    }) }));
function ProfileApplicationHistory() {
    const intl = (0, react_intl_1.useIntl)();
    const socket = (0, socket_context_1.useSocket)();
    const [applicationsStatuses, setApplicationStatuses] = react_1.default.useState([]);
    const [pageStats, setPageStats] = react_1.default.useState({
        page: 1,
        pageCount: 1,
        total: 0,
    });
    const isMdOrLowerLayout = Boolean((0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('md')));
    const init = async () => {
        const myApplicationsStatuses = await Api.OfferApplication.getMyOfferApplicationsStatuses(pageStats.page);
        const newPageStats = myApplicationsStatuses.pageStats;
        setApplicationStatuses(myApplicationsStatuses.applications);
        setPageStats({
            page: newPageStats.page,
            pageCount: newPageStats.pageCount,
            total: newPageStats.rowCount,
        });
    };
    async function onStatusUpdated(applicationId) {
        const updatedApplicationStatus = await Api.OfferApplication.getMyOfferApplicationStatus(applicationId);
        setApplicationStatuses(prevValues => {
            const nonUpdatedApplications = prevValues.filter(application => application.id !== updatedApplicationStatus.id);
            const newApplicationsStatuses = [...nonUpdatedApplications, updatedApplicationStatus].sort((first, second) => new Date(second.createdAt).valueOf() - new Date(first.createdAt).valueOf());
            return newApplicationsStatuses;
        });
    }
    react_1.default.useEffect(() => {
        init();
        socket.on(types_1.SocketEvents.APPLICATION_STATUS_UPDATED, onStatusUpdated);
    }, []);
    const loadMoreApplications = async () => {
        const newApplicationStatuses = await Api.OfferApplication.getMyOfferApplicationsStatuses(pageStats.page + 1);
        const newPageStats = newApplicationStatuses.pageStats;
        const newApplications = newApplicationStatuses.applications;
        setPageStats({
            page: newPageStats.page,
            pageCount: newPageStats.pageCount,
            total: newPageStats.rowCount,
        });
        setApplicationStatuses([...applicationsStatuses, ...newApplications]);
    };
    if (pageStats.total === 0) {
        return ((0, jsx_runtime_1.jsx)(MissingContentView_1.default, { heading: intl.formatMessage({
                id: 'profile.application_history.no_applications',
            }), message: intl.formatMessage({
                id: 'profile.application_history.didnt_send_any_requests',
            }), children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", "data-cy": "add-offer", link: "/ponuky", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.application_history.go_to_offers_list" }) }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(ApplicationList, { applicationsStatuses: applicationsStatuses, isSmallLayout: isMdOrLowerLayout, intl: intl }), pageStats.total > 6 && pageStats.page < pageStats.pageCount && ((0, jsx_runtime_1.jsx)("div", { className: "bottom-line", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: loadMoreApplications, color: "brand", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.application_history.show_more" }) }) }))] }));
}
exports.default = ProfileApplicationHistory;
